<template>
  <v-card flat color="grey lighten-4 pt-2">
    <v-subheader class="" v-text="title"></v-subheader>
    <WorkspaceUserSelect
      v-model="usersToAdd"
      class="px-4"
      :typeAheadList="typeAheadList"
      :label="label"
      :dropDownList="dropDownList"
    ></WorkspaceUserSelect>
    <v-card-actions>
      <template v-if="inviting">
        <v-btn
          color="primary"
          @click.native="inviteAuthors"
          :loading="sendingInvite"
          :disabled="!usersToAdd.length"
          v-text="actionLabel"
        ></v-btn>
        <v-btn color="grey" text outlined @click.native="cancelInvite">Cancel</v-btn>
      </template>
    </v-card-actions>
    <v-alert v-model="alert" dismissible type="info" outlined>
      <p v-if="usersNotSignedUp.length > 1">
        We've sent an invitation to these email addresses.
      </p>
      <p v-else>
        We've sent an invitation to this email address:
      </p>
      <ul>
        <li v-for="email in usersNotSignedUp" :key="email">{{ email }}</li>
      </ul>
    </v-alert>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import WorkspaceUserSelect from '@/components/WorkspaceUserSelect';
export default {
  props: ['typeAheadList', 'dropDownList', 'actionLabel', 'title', 'label', 'workspace'],
  components: { WorkspaceUserSelect },
  data() {
    return {
      usersToAdd: [],
      collaborators: [],
      sendingInvite: false,
      usersNotSignedUp: []
    };
  },
  watch: {
    inviting: function(newValue) {
      console.log(newValue);
      if (newValue) {
        this.$emit('inviting');
      } else {
        this.$emit('notInviting');
      }
    }
  },
  computed: {
    ...mapGetters('workspaces', ['collaboratorDirectory']),
    inviting() {
      return !!this.usersToAdd.length;
    },
    alert: {
      get: function() {
        return this.usersNotSignedUp.length > 0;
      },
      set: function(newValue) {
        return !newValue ? (this.usersNotSignedUp = []) : null;
      }
    }
  },
  methods: {
    ...mapActions('auth', ['getUserByEmail', 'sendInvite']),
    ...mapActions('workspaces', ['addWorkspaceMember']),
    async inviteAuthors() {
      this.sendingInvite = true;
      this.usersNotSignedUp = [];
      const emails = [];
      const newUsers = [];
      this.usersToAdd.forEach(a => {
        if (typeof a == 'string') {
          emails.push(a);
        } else {
          newUsers.push(a);
        }
      });
      console.log(emails);

      if (emails.length) {
        // make one call to getUsersByEmails
        const userByEmailResult = await this.getUserByEmail(emails);
        //  Returns object with userData and emailsNotFound
        console.log(userByEmailResult);
        if (userByEmailResult.emailsNotFound.length) {
          userByEmailResult.emailsNotFound.forEach(e => this.usersNotSignedUp.push(e));
        }
        if (userByEmailResult.userData.length) {
          userByEmailResult.userData.forEach(r => newUsers.push(r));
        }

        if (this.usersNotSignedUp.length) {
          console.log(this.workspace);
          this.usersNotSignedUp.forEach(email => {
            this.sendInvite({
              email,
              workspace: { id: this.workspace.id, name: this.workspace.profile.name }
            });
          });
        }
      }

      this.$emit('inviteUsers', newUsers);
      //  add each newId to author;
      // newUsers.map(user => {
      //   try {
      //     console.log(user);
      //     //  individually add new members
      //     //  user is { id, avatar, name }
      //     //this.addWorkspaceMember({ workspaceId: this.workspace.id, user });
      //   } catch (e) {
      //     console.log(e);
      //   }
      // });
      this.cancelInvite();
    },
    cancelInvite() {
      this.sendingInvite = false;
      this.usersToAdd = [];
      this.$emit('notInviting');
    }
  }
};
</script>

<style></style>
